// CPK-3700: touch marker so this push's changeset includes frontend/** for the manual deploy trigger.
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { LoginComponent } from './pages/login/login.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { SignupComponent } from './pages/signup/signup.component';
import { VerifyComponent } from './pages/verify/verify.component';
import { OneTimeLinkComponent } from './pages/one-time-link/one-time-link.component';
import { LinkExpiredComponent } from './pages/link-expired/link-expired.component';
import { LanguageGuard } from 'src/app/core/guards/language.guard';
import { AgentLoginComponent } from './pages/agent-login/agent-login.component';
import { AlreadyAuthenticatedGuard } from 'src/app/core/guards/already-authenticated.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: 'login', component: LoginComponent, canActivate: [AlreadyAuthenticatedGuard] },
      { path: 'login/agent', component: AgentLoginComponent, canActivate: [AlreadyAuthenticatedGuard] },
      { path: 'signup', component: SignupComponent, canActivate: [AlreadyAuthenticatedGuard] },
      { path: 'forgot', component: ForgotPasswordComponent },
      { path: 'recovery', component: ForgotPasswordComponent },
      { path: 'confirm', component: VerifyComponent },
      { path: 'otl', component: OneTimeLinkComponent },
      { path: 'link-expired', component: LinkExpiredComponent },
      { path: '**', redirectTo: '/login', pathMatch: 'full' },
    ],
    canActivate: [LanguageGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RootRoutingModule {}
